// frontend/src/pages/VerificationPending.jsx
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "../../services/authService";
import styles from "./verificationPending.module.scss";

const VerificationPending = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const handleResendEmail = async () => {
    try {
      setIsLoading(true);
      setMessage("");

      const token = localStorage.getItem("token");
      if (!token) {
        navigate("/connect");
        return;
      }

      const response = await api.post(
        "/auth/resend-verification",
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setMessage(response.data.message);
    } catch (error) {
      setMessage(
        error.response?.data?.message || "Erreur lors du renvoi de l'email"
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="verificationationPending">
      <div className="verificationationPending-container">
        <div>
          <h1>Verification de votre email</h1>
          <div className="verificationationPending-content">
            <p>Un email de vérification a été envoyé à votre adresse.</p>
            <p>
              Veuillez cliquer sur le lien dans l'email pour activer votre
              compte.
            </p>
          </div>
        </div>

        {message && (
          <div
            className={`resend-email ${
              message.includes("Erreur") ? "text-red-600" : "text-green-600"
            }`}
          >
            {message}
          </div>
        )}

        <div>
          <div className="resend-email-container">
            <p className="text-gray-600">Vous n'avez pas reçu l'email ?</p>
            <button
              className={`mt-2${
                isLoading ? "opacity-50 cursor-not-allowed" : ""
              }`}
              onClick={handleResendEmail}
              disabled={isLoading}
            >
              {isLoading
                ? "Envoi en cours..."
                : "Renvoyer l'email de vérification"}
            </button>
          </div>
          <div className="">
            <Link to="/connect" className="verification-pending-exit">
              Accès à l'appli / Retour à la connexion
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerificationPending;
